import React, { useState, useEffect } from "react";
import OtpInputPage from "./otpInputPage";
import { useForm } from "react-hook-form";
import { createSignup, loginSelector, ValidateOTP } from "../store/slices/login"
import { useDispatch, useSelector } from 'react-redux';
import AppConfig from "../appConfig";
import { Button, TextField, Stack, Card, Divider, Typography } from "@mui/material";
import Navbar from "./navbar";
import { v4 } from 'uuid';

const USERID = 'userId'

const Login = ({ }) => {
    const dispatch = useDispatch();
    const { loginDetails, otpResponse, validOtp } = useSelector(loginSelector);
    const { handleSubmit } = useForm();
    const [showOtp, showOtpScreen] = useState(false);
    const [email, onChangeEmail] = useState('');
    const [firstName, setFirstName] = React.useState("");
    const [lastName, setLastName] = React.useState("");
    const [otpResent, setOtpResent] = React.useState(false);
    const [invalidEmail, setInvalidEmail] = React.useState(false);


    const resendOtp = () => {
        onSubmit();
    }
    useEffect(() => {
        if (typeof loginDetails == "number") {

        }
        else if (loginDetails?.id) {
            showOtpScreen(true)
            localStorage.setItem(USERID, loginDetails?.id)
        }


    }, [loginDetails]);

    const onAuthenticateLogin = (id, otp) => {
        dispatch(ValidateOTP(id, otp))
        setOtpResent(false)
    };

    const validateEmail = (email) => {
        return String(email)
            .toLowerCase()
            .match(
                /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
            );
    };
    const onSubmit = () => {
        if (validateEmail(email)) {
            dispatch(createSignup({ firstName, lastName, email }));
            setInvalidEmail(false);
        }
        else {
            setInvalidEmail(true);
        }
    }

    return (
        <div className="demo-container" style={{ width: '100%', height: '100vh' }}>
            <Stack className="mt-2" sx={{ marginTop: '3rem' }}>
                <Card className="mt-2" st>
                    <Stack >
                        <Navbar />
                        {!showOtp &&
                            <form style={{ display: 'flex', flexDirection: 'column', alignContent: 'center', boxShadow: 'rgba(0, 0, 0, 0.2) 0px 0px 0px 1px, rgba(0, 0, 0, 0.14) 1px 1px 10px 5px, rgba(0, 0, 0, 0.12) 0px 1px 1px 0px' }} onSubmit={handleSubmit(onSubmit)}>

                                <Stack py={2} spacing={2} className="mb-3" sx={{ alignItems: "center", margin: '100px' }}>
                                    {/* <label htmlFor="exampleInputEmail1" className="form-label">Email address</label> */}
                                    <div className="align-items-center">
                                        <img width={100} id="app-logo" src="~/../upload_icon.svg" alt="Upload Portal" />
                                    </div>
                                    <TextField required sx={{ width: '500px' }}
                                        id="txtEmail"
                                        type="text"
                                        value={email}
                                        label="Enter your email address to get your verification code" variant="outlined"
                                        inputlabelprops={{ shrink: true }}
                                        // placeholder="Enter your email address to get your verification code"
                                        onChange={(e) => { onChangeEmail(e.target.value.trimStart()) }}
                                    />
                                    {invalidEmail &&
                                        <div style={{ marginBottom: '10px', width: '300px' }}>
                                            <label style={{ color: 'red' }}> Please enter a valid email address</label>
                                        </div>
                                    }
                                    <div>
                                        <Button type="submit" sx={{ minWidth: '150px' }} variant="contained">Send Code</Button>
                                    </div>
                                    {typeof loginDetails == "number" && <Typography color={'red'}>{"You are not authorised to access this application."}</Typography>}
                                </Stack>


                            </form>
                        }
                        {showOtp &&
                            <OtpInputPage onAuthenticateLogin={onAuthenticateLogin}
                                otpResponse={otpResponse}
                                resendOtp={resendOtp}
                                otpResent={otpResent}
                                setOtpResent={setOtpResent}
                                loginDetails={loginDetails} />
                        }
                    </Stack>

                </Card>
                {/* <Divider flexItem /> */}
                {/* <Card>
                    <img src={`https://static.rightresponse.ai/images/MRTSS.png`}
                        onError={(e) => { e.target.onerror = null; e.target.src = "https://static.rightresponse.ai/images/MRTSS.png" }} alt='MRT' style={{ width: '100%', filter: 'blur(1px)' }} />
                </Card> */}
            </Stack>
        </div>

    );
}

export default Login;